import { DataAdapter } from "@/DataAdapter/DataAdapter";

import {
	SavedLiveTagRequest,
	SavedLiveTagResponse,
} from "@/model/SATOSLive/Settings/SavedTagValue";
import { LiveSettingsRequest } from "@/model/SATOSLive/Settings/SettingsRequest";
import { LiveSettingsResponse } from "@/model/SATOSLive/Settings/SettingsResponse";

export const fetchLiveSettings = (): Promise<LiveSettingsResponse> => {
	return DataAdapter.Get<LiveSettingsResponse>({
		endpoint: "SatosLive/Settings",
	});
};

export const postLiveSettings = (
	request: LiveSettingsRequest,
): Promise<LiveSettingsResponse> => {
	return DataAdapter.Post<LiveSettingsResponse>("SatosLive/Settings", request);
};

export const saveLiveTagValue = (
	request: SavedLiveTagRequest,
): Promise<SavedLiveTagResponse> => {
	return DataAdapter.Post<SavedLiveTagResponse>(
		"SatosLive/SaveLiveTagValue",
		request,
	);
};
